// extracted by mini-css-extract-plugin
export default {"SameEmail":"SameEmail_SameEmail__N7NBi","title":"SameEmail_title__6D5mY","btnred":"SameEmail_btnred__4OFYR"};